import axiosInstance from '../utils/axiosConfig';

export interface BusinessType {
  id: number;
  name: string;
}

export const listBusinessTypes = async () => {
  const { data } = await axiosInstance.get<BusinessType[]>('/api/v1/business-types');
  return data;
}; 